import { mapModelToDto, mapDtoToModel } from './mappers';

export { resourceService } from './resources-service';
export const ResourceMappers = { mapModelToDto, mapDtoToModel };
export type { ResourceDto } from './types';
